import { Th, Td } from 'xpi-black-ui/Common/Table';
import Bullet from 'xpi-black-ui/Base/Bullet';
import Tooltip from 'xpi-black-ui/Base/Tooltip';
import styled, { css } from 'styled-components';
import { SomaIcon, SomaSpinner } from '@soma/react';

const COLOR_BULLET = {
  'WaitingPrice': '#3597DB',
  'Aguardando Aprovação': '#3597DB',
  'A Executar': '#3597DB',
  'Pendente Execução': '#3597DB',
  'Validando Execução': '#3597DB',
  'Pendente Registro': '#3597DB',
  'Aceito': '#02DB18',
  'Precificado': '#02DB18',
  'Pré-precificado': '#FFC709',
  'Solicitado': '#FFC709',
  'Enviado CLiente': '#FFC709',
  'Aceito': '#FFC709',
  'Registrado':'#FFC709',
  'Executado': '#02DB18',
  'Totalmente Executado': '#02DB18',
  'Cancelado': '#FF0026',
};

const WrapperActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export default WrapperActions;

export const CustomTh = styled(Th)`
  ${({ isSticky }) => isSticky && css`
    position: sticky;
    left: -16px;
    background-color: #34343a;
  `};
`;

export const CustomTd = styled(Td)`
  ${({ isSticky }) => isSticky && css`
    position: sticky;
    left: -16px;

    &:nth-child(odd) {
      background-color: #3f4147;
    }
  `};
`;

export const CustomTooltip = styled(Tooltip)`
    margin-top: -8px;
    position: absolute;
`;

export const StatusBullet = styled(Bullet).attrs(({ name }) => ({ color: COLOR_BULLET[name] || '#47494e' }))``;

export const CancelOrder = styled(SomaIcon)`
    cursor: pointer;
`;

export const CancelLoading = styled(SomaSpinner)`
  border-color: rgb(255 255 255) rgba(18, 18, 18, 0.153) rgba(18, 18, 18, 0.153);
`;

export const UnderlineText = styled.span`
  text-decoration: underline;
  text-underline-offset: 4px;
  text-decoration-style: dashed;
`;
